import React from 'react';

interface RadioProps {
  value: string;
  checked: boolean;
  fnCallback: () => void;
  disabled: boolean;
}

const Radio = (props: RadioProps) => {
  const fnCallback = () => {
    if (!props.disabled) {
      props.fnCallback();
    }
  };

  return (
    <div className="custom-control custom-radio" onClick={() => fnCallback()} onKeyDown={() => fnCallback()}>
      <input
        className="custom-control-input"
        type="radio"
        name="exampleRadios"
        checked={props.checked}
        value={props.value}
        disabled={props.disabled}
        onChange={() => fnCallback()}
      />
      <label className="custom-control-label" />
    </div>
  );
};

export default Radio;
